import { useEffect, useRef } from "react";

const useKeyboardAdjustments = () => {
    const focusRecentlyOccurred = useRef(false);
    const lastScrollPosition = useRef({
        window: 0,
        mainLayoutSection: 0,
        overflowYAuto: new Map(), // Using a Map to track scroll positions of multiple elements
    });

    const handleFocusIn = () => {
        focusRecentlyOccurred.current = true;
        setTimeout(() => (focusRecentlyOccurred.current = false), 300);
    };

    const handleScroll = (event) => {
        const target = event.target;
        
        // Process scroll events for the main screen and hide the keyboard
        if (target && target.closest) {
            if (target && (target.closest(".select__menu-list") || target.closest(".team-user-select") || target.closest(".select__input") || target.closest(".select__input-container"))) {
                return; // Ignore scroll events originating from elements within 'select__menu-list'
            }
        }

        const currentScroll = target === document ? window.scrollY : target.scrollTop;
        const lastScroll =
            target === document
                ? lastScrollPosition.current.window
                : target.classList.contains("main__layout_section")
                    ? lastScrollPosition.current.mainLayoutSection
                    : lastScrollPosition.current.overflowYAuto.get(target) || 0;

        if (Math.abs(currentScroll - lastScroll) > 10 && !focusRecentlyOccurred.current) {
            if (document.activeElement) {
                document.activeElement.blur(); // Hide the keyboard
            }
        }

        // Update last scroll position
        if (target === document) {
            lastScrollPosition.current.window = currentScroll;
        } else if (target.classList.contains("main__layout_section")) {
            lastScrollPosition.current.mainLayoutSection = currentScroll;
        } else {
            lastScrollPosition.current.overflowYAuto.set(target, currentScroll);
        }
    };

    useEffect(() => {
        // Set up or update event listeners
        const setupEventListeners = () => {
            window.addEventListener("focusin", handleFocusIn);
            window.addEventListener("scroll", handleScroll, true);
            document.querySelector(".main__layout_section")?.addEventListener("scroll", handleScroll, true);

            document.querySelectorAll(".overflow-y-auto").forEach((element) => {
                lastScrollPosition.current.overflowYAuto.set(element, element.scrollTop);
                element.addEventListener("scroll", handleScroll, true);
            });
        };

        setupEventListeners(); // Call on initial mount

        return () => {
            // Cleanup function
            window.removeEventListener("focusin", handleFocusIn);
            window.removeEventListener("scroll", handleScroll, true);
            document.querySelector(".main__layout_section")?.removeEventListener("scroll", handleScroll, true);
            document.querySelectorAll(".overflow-y-auto").forEach((element) => {
                element.removeEventListener("scroll", handleScroll, true);
            });
        };
    }, []);

    return null;
};

export default useKeyboardAdjustments;
